// extracted by mini-css-extract-plugin
export var readonly = "_jc-1";
export var star = "_jc-0";